import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("awzdE"), parcelRequire.load("kWrGa"), parcelRequire.load("b2oLn"), parcelRequire.load("i12bk"), parcelRequire.load("jVShT"), parcelRequire.load("xRGNG"), parcelRequire.load("blC0m"), parcelRequire.load("kTb4A"), parcelRequire.load("5YCil")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("awzdE")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("kWrGa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("b2oLn")} />
  <link rel="modulepreload" href={parcelRequire.resolve("i12bk")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jVShT")} />
  <link rel="modulepreload" href={parcelRequire.resolve("xRGNG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("blC0m")} />
  <link rel="modulepreload" href={parcelRequire.resolve("kTb4A")} />
  <link rel="modulepreload" href={parcelRequire.resolve("5YCil")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
